module.exports = __webpack_public_path__ + "static/scale-model-of-elephant-trails-in-washington-d.c.-209041e4873b2aa737dbe6e771fd65b1.png";